import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../../pagescss/OnlinePracticsQuestions.css';
import AllQuestions from '../AllData/AllQuestions';
import Loading from '../home/Loading';
import Latex from 'react-latex';
import TopNavbar from '../home/TopNavbar';
import QuestionImage from './QuestionImage';




const OnlinePracticeQuestions = () => {
    const [loading, setLoading] = useState(true);
    const { subject, topic, type } = useParams();
    const questions = AllQuestions;
    const [questionList, setQuestionList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showAnswer, setShowAnswer] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [bookmarkedQuestions, setBookmarkedQuestions] = useState([]);
    const [savedQuestions, setSavedQuestions] = useState([]);
    const [attend, setAttend] = useState(false);
    const [allQuestions, setAllQuestions] = useState([]);
    const [practiceMode, setPracticeMode] = useState(true);
    const [timeElapsed, setTimeElapsed] = useState(0);
    const timerRef = useRef(null);
    const [showContent, setShowContent] = useState(false);

    const handleToggle = () => {
        setShowContent(!showContent);
    };

    const userPayment = localStorage.getItem('userPayment');



    // Load bookmarks from localStorage
    useEffect(() => {
        const storedBookmarks = localStorage.getItem('questionBookmarks');
        if (storedBookmarks) {
            setBookmarkedQuestions(JSON.parse(storedBookmarks));
        }
        setLoading(false);
    }, []);


    useEffect(() => {
        if (!showAnswer && questionList.length > 0) {
            startTimer();
        } else {
            stopTimer();
        }
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [currentIndex, showAnswer, questionList.length]);

    const startTimer = () => {
        setTimeElapsed(0);
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }

        timerRef.current = setInterval(() => {
            setTimeElapsed(prevTime => prevTime + 1);
        }, 1000);
    };

    const stopTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    useEffect(() => {
        const filteredQuestions = questions.filter(question =>
            question.subject === subject &&
            question.type === type &&
            (question.topic === topic || question.year === topic)
        );
        setAllQuestions(filteredQuestions);
        setQuestionList(filteredQuestions);
        setLoading(false);
    }, [questions, subject, topic, type]);

    // Helper function to compare question IDs (handles both string and object formats)
    const compareQuestionIds = (id1, id2) => {
        // Extract the actual ID string from both IDs
        const extractId = (id) => {
            if (typeof id === 'object' && id.$oid) {
                return id.$oid; // MongoDB ObjectId format
            }
            return id; // String format
        };

        return extractId(id1) === extractId(id2);
    };

    // Handle bookmark toggle with localStorage
    const handleBookmark = () => {
        //  if (!userId) {
        //     setShowLoginMessage(true);
        //      return;
        //   }

        const currentQuestion = questionList[currentIndex];
        const isBookmarked = bookmarkedQuestions.some(
            bq => compareQuestionIds(bq.questionId, currentQuestion._id)
        );

        let updatedBookmarks;

        if (isBookmarked) {
            // Remove bookmark
            updatedBookmarks = bookmarkedQuestions.filter(
                bq => !(compareQuestionIds(bq.questionId, currentQuestion._id))
            );
        } else {
            // Add bookmark
            const newBookmark = {
                questionId: currentQuestion._id, // Store the ID as-is (could be object or string)
                timestamp: new Date().toISOString()
            };
            updatedBookmarks = [...bookmarkedQuestions, newBookmark];
        }

        // Update localStorage and state
        localStorage.setItem('questionBookmarks', JSON.stringify(updatedBookmarks));
        setBookmarkedQuestions(updatedBookmarks);
    };

    const isQuestionBookmarked = () => {
        const currentQuestion = questionList[currentIndex];
        return bookmarkedQuestions.some(
            bq => compareQuestionIds(bq.questionId, currentQuestion._id)
        );
    };






    const storeQuestions = (questionsId) => {
        const storedQuestionsIdInLocalStorage = JSON.parse(localStorage.getItem('saveQuestionsIdInLocalStorage')) || [];

        if (!storedQuestionsIdInLocalStorage.includes(questionsId)) {
            const updatedsaveQuestionsInLocalStorage = [...storedQuestionsIdInLocalStorage, questionsId];
            localStorage.setItem('saveQuestionsIdInLocalStorage', JSON.stringify(updatedsaveQuestionsInLocalStorage));
        }
        const storedQuestions = JSON.parse(localStorage.getItem('saveQuestionsIdInLocalStorage')) || [];
        setSavedQuestions(storedQuestions);
        setAttend(true);
    };

    // Load saved question IDs on component mount
    useEffect(() => {
        const storedQuestions = JSON.parse(localStorage.getItem('saveQuestionsIdInLocalStorage')) || [];
        setSavedQuestions(storedQuestions);
    }, []);

    const isQuestionAttend = () => {
        const currentQuestion = questionList[currentIndex];
        return savedQuestions.includes(currentQuestion._id.$oid);
    };

    const handleFilterChange = (newFilterValue) => {

        if (newFilterValue === "all") {
            setQuestionList(allQuestions);
        } else if (newFilterValue === "attended") {
            const attendQuestions = allQuestions.filter(question =>
                savedQuestions.includes(question._id.$oid)
            );
            setQuestionList(attendQuestions);
        } else if (newFilterValue === "unattended") {
            const unAttendQuestions = allQuestions.filter(question =>
                !savedQuestions.includes(question._id.$oid)
            );
            setQuestionList(unAttendQuestions);
        } else if (newFilterValue === "practice") {
            setPracticeMode(true);
        } else if (newFilterValue === "revision") {
            setPracticeMode(false);
        }
    };

    const handleNext = () => {
        setCurrentIndex(prev => (prev + 1) % questionList.length);
        setShowAnswer(false);
        setSelectedOption(null);
        setAttend(false);
        setShowContent(false);
    };

    const handlePrev = () => {
        setCurrentIndex(prev => (prev - 1 + questionList.length) % questionList.length);
        setShowAnswer(false);
        setSelectedOption(null);
        setAttend(false);
    };

    const handleOptionSelect = async (option) => {
        setSelectedOption(option);
        setShowAnswer(true);
        await storeQuestions(questionList[currentIndex]._id.$oid);
    };

    // Function to render text with LaTeX
    const renderWithLatex = (text) => {
        if (!text) return null;

        // Check if text contains LaTeX patterns
        if (text.includes('$') || text.includes('\\')) {
            return <Latex>{text}</Latex>;
        }
        return text;
    };



    if (loading) {
        return <Loading message='Loading......' />;
    }

    if (questionList.length === 0) {
        return <div className="question-card">
            <br></br>
            <div className='question-header'>
                <h1>Questoins not found</h1>
            </div>

        </div>;
    }

    const currentQuestion = questionList[currentIndex];
    const currentQuestionText = renderWithLatex(currentQuestion.question);
    return (
        <div className="practice-container">

            <TopNavbar name={currentQuestion.subject + ": (" + (currentIndex + 1) + " of " + (questionList.length) + ") " + (currentQuestion.topicname ? (currentQuestion.topicname) : ("")) + (currentQuestion.year ? ("NEET " + currentQuestion.year) : (""))} />

            {practiceMode ? (
                <div className="question-card">
                    <div className="question-header">

                        <br></br>

                        <span className="question-topic">({currentIndex + 1} of {questionList.length}) {currentQuestion.subject}: {currentQuestion.topicname} (NEET {currentQuestion.year})</span>


                        <div className="header-controls">
                            <select
                                className="filter-buttom"
                                onChange={(e) => handleFilterChange(e.target.value)}
                            >
                                <option value="all">Filter all</option>
                                <option value="attended">Attend</option>
                                <option value="unattended">Unattend</option>
                                <option value="revision">Revision</option>
                            </select>

                            {isQuestionAttend() || attend ? (
                                <span className="attend-text">Attend</span>
                            ) : (
                                <span className="not-attend-text">Unattend</span>
                            )}

                            <div className="timer">
                                <span className="timer-icon">⏱️</span>
                                <span className="timer-text">{formatTime(timeElapsed)}</span>
                            </div>


                            <button
                                onClick={handleBookmark}
                                className={`bookmark-button ${isQuestionBookmarked() ? 'bookmarked' : ''}`}
                            >
                                <span className='bookmark-text'>{isQuestionBookmarked() ? <p className='mark-text'>Marked</p> : <p className='mark-text'>Mark</p>}</span>
                            </button>

                        </div>
                    </div>

                    <div className="question-content">
                        {type === "dpp" ? (<>
                            {currentQuestion.question ? (
                                <p className="question-text">
                                    {renderWithLatex(currentQuestion.question)}
                                </p>
                            ) : (
                                <QuestionImage
                                    src={`/questionsPhoto/${currentQuestion.question_img}`}
                                    alt="Question"
                                />
                            )}

                            <button onClick={handleToggle} style={{ fontSize: "8px", padding: "01px" }}>
                                {showContent ? "Hide source image" : "View source image"}
                            </button>
                            {showContent && (
                                <div style={{ padding: "5px" }}>
                                    <QuestionImage
                                        src={`/questionsPhoto/${currentQuestion.question_img}`}
                                        alt="Question"
                                    />
                                </div>
                            )}


                        </>) : (<>
                            <QuestionImage
                                src={`/questionsPhoto/${currentQuestion.question_img}`}
                                alt="Question"
                            />
                        </>)}


                    </div>


                    {/*  <p>{currentQuestion.answer}</p>   */}





                    <div className="options-container">
                        {['option1', 'option2', 'option3', 'option4'].map((option, index) => (

                            <div
                                key={option}
                                className={`option-item 
                                ${selectedOption === option ? 'selected' : ''}
                                ${showAnswer && currentQuestion.answer === option ? 'correct' : ''}
                                ${showAnswer && selectedOption === option && selectedOption !== currentQuestion.answer ? 'incorrect' : ''}
                            `}
                                onClick={() => handleOptionSelect(option)}
                            >
                                <span className="option-letter">{String.fromCharCode(65 + index)}</span>
                                <span className="option-text">
                                    {renderWithLatex(currentQuestion[option])}
                                </span>
                            </div>
                        ))}
                    </div>






                    <div className="navigation-controls">
                        <button
                            className="nav-button prev-button"
                            onClick={handlePrev}
                            disabled={currentIndex === 0}
                        >
                            Previous
                        </button>

                        <button
                            className="nav-button next-button"
                            onClick={handleNext}
                            disabled={currentIndex === questionList.length - 1}
                        >
                            Next
                        </button>
                    </div>

                    {showAnswer && (
                        <>

                            {userPayment ? (<>
                                <Link to={`/report-send/${currentQuestion._id.$oid}`} className="report-btn"  >  Send report if we mistake with answer </Link>
                           <br></br>
                            </>) : (<></>)}


                           


                            <div className="answer-section">


                                <p className="correct-answer">
                                    <strong>Correct Answer: </strong>
                                    {renderWithLatex(currentQuestion[currentQuestion.answer])}
                                </p>
                                <p className="question-solution">
                                    <strong>Solution:</strong>
                                    {userPayment ? (<>
                                        {currentQuestion.solutionimg ? (
                                            <QuestionImage
                                                src={`/solutionsimg/${currentQuestion.solutionimg}.png`}
                                                alt="Solution"
                                                className='question-img-solutin'
                                            />
                                        ) : (
                                            <>
                                                {currentQuestion.solution.split('\n').map((line, index) => (
                                                    <span key={index}>
                                                        {renderWithLatex(line)}
                                                        <br />
                                                    </span>
                                                ))}
                                            </>
                                        )}
                                    </>) : (<>
                                        <div className="subscription-box">

                                       

                                            <div className="price-info">
                                                <span className="membership-text">To view solution please</span>
                                            </div>

                                            <Link to="/premium-paywall" className="pay-button">
                                                Subscribe & Unlock Now
                                            </Link>
                                        </div>
                                    </>)}

                                </p>
                                <p className="time-taken">
                                    <strong>Time Taken: </strong>
                                    {formatTime(timeElapsed)}
                                </p>
                            </div> </>
                    )}
                </div>
            ) : (
                <div className="question-card">
                    <h3>Revision Mode: </h3>
                    <select
                        className="filter-buttom"
                        onChange={(e) => handleFilterChange(e.target.value)}
                    >
                        <option value="revision">Revision Mode</option>
                        <option value="practice">Practice Mode</option>
                    </select>



                    {allQuestions.map((question, index) => (
                        <div key={index} className="revision-question-container">

                            <div className="question-content">

                                {type === "dpp" ? (<>
                                    {currentQuestion.question ? (
                                        <p className="question-text">
                                            {renderWithLatex(currentQuestion.question)}
                                        </p>
                                    ) : (
                                        <QuestionImage
                                            src={`/questionsPhoto/${currentQuestion.question_img}`}
                                            alt="Question"
                                        />
                                    )}

                                    <button onClick={handleToggle} style={{ fontSize: "8px", padding: "01px" }}>
                                        {showContent ? "Hide source image" : "View source image"}
                                    </button>
                                    {showContent && (
                                        <div style={{ padding: "5px" }}>
                                            <QuestionImage
                                                src={`/questionsPhoto/${currentQuestion.question_img}`}
                                                alt="Question"
                                            />
                                        </div>
                                    )}


                                </>) : (<>
                                    <QuestionImage
                                        src={`/questionsPhoto/${currentQuestion.question_img}`}
                                        alt="Question"
                                    />
                                </>)}


                            </div>

                            <div className="correct-answer">
                                <p>Answer:
                                    {question.answer === "option1" ? renderWithLatex(question.option1) :
                                        question.answer === "option2" ? renderWithLatex(question.option2) :
                                            question.answer === "option3" ? renderWithLatex(question.option3) :
                                                renderWithLatex(question.option4)}
                                </p>
                            </div>

                            <Link to={`/question-solution/${question._id.$oid}`} className="action-btn view-btn"  >  View Solution  </Link>


                            <hr style={{ "margin-top": "7px" }}></hr>


                        </div>

                    ))}
                </div>
            )}
        </div>
    );
};

export default OnlinePracticeQuestions;